var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 190.01 131.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n                isolation: isolate;\n            }\n\n            .cls-2 {\n                fill: none;\n            }\n\n            .cls-3 {\n                fill: #356359;\n            }\n\n            .cls-4 {\n                fill: #449e8a;\n            }\n\n            .cls-5 {\n                fill: #1a2442;\n            }\n\n            .cls-6 {\n                fill: #823312;\n            }\n\n            .cls-7 {\n                fill: #5d0f24;\n            }\n\n            .cls-8 {\n                fill: #223361;\n            }\n\n            .cls-9 {\n                fill: #ae1831;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Laag_2-2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "taptoe",
    className: ""
  }, /*#__PURE__*/React.createElement("g", {
    className: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.86,117a7,7,0,0,0,2.25-.37v4.92a13.12,13.12,0,0,1-3.44.5c-4.35,0-7.54-1.69-7.54-7.42v-8.7h-3v-4.79h3V95h5.94v6.07h5v4.79h-5v8.37C41.07,116.15,41.93,117,43.86,117Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.14,118.49C60.83,121,58.45,122,55.63,122c-3.41,0-6.73-1.81-6.73-5.87,0-8.69,13-4.79,13-8.81,0-1.44-1.39-2.3-3.24-2.3-2.05,0-3.32,1.11-3.32,3.12H49.52c0-5.37,4.59-7.46,9.34-7.46s9,1.88,9,6.8v14.11H62.14Zm-4.71-.86c2.46,0,4.59-1.44,4.59-4.18v-1.07c-2.83,1.27-7.17.9-7.17,3.28C54.85,117,56,117.63,57.43,117.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.38,119.15v12.71H72.44V101.11H78.3v2.58a7.72,7.72,0,0,1,6.15-3C90,100.7,94,105,94,111.36S90,122,84.45,122A7.79,7.79,0,0,1,78.38,119.15Zm9.76-7.79c0-3.24-2.09-5.38-4.88-5.38s-4.88,2.14-4.88,5.38,2.09,5.37,4.88,5.37S88.14,114.6,88.14,111.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.61,117a7.13,7.13,0,0,0,2.26-.37v4.92a13.2,13.2,0,0,1-3.45.5c-4.34,0-7.54-1.69-7.54-7.42v-8.7H95.93v-4.79h2.95V95h5.94v6.07h5.05v4.79h-5.05v8.37C104.82,116.15,105.69,117,107.61,117Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.2,111.36A10.67,10.67,0,1,1,122.86,122,10.27,10.27,0,0,1,112.2,111.36Zm15.54,0c0-3.24-2-5.38-4.88-5.38s-4.87,2.14-4.87,5.38,2.09,5.37,4.87,5.37S127.74,114.55,127.74,111.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.65,113h-15c.5,2.7,2.14,4.14,4.84,4.14,1.89,0,3.12-.66,3.69-2h6c-1.27,4.51-4.84,6.89-9.88,6.89-6,0-10.38-4.39-10.38-10.66s4.35-10.66,10.38-10.66,10.37,4.38,10.37,10.66C156.73,111.93,156.69,112.46,156.65,113Zm-14.93-3.49H151a4.7,4.7,0,0,0-9.27,0Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "59.64 58.53 59.63 58.53 59.64 58.54 59.64 58.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143.78,43.89H133.6A23.12,23.12,0,0,0,110.49,67h56.4A23.12,23.12,0,0,0,190,43.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M133.6,43.89h9.22L109.38,4.44A12.53,12.53,0,0,0,99.93,0V33.7A33.28,33.28,0,0,1,66.63,67h43.86A23.12,23.12,0,0,1,133.6,43.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.34,43.89H56.76l-4.25,5h0L49.3,52.69h0l-4.91,5.8L37.18,67v0H66.63A33.31,33.31,0,0,0,98.34,43.89ZM59.64,58.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M72.28,25.58l-4.54,5.36-11,13H98.34A33.28,33.28,0,0,0,99.93,33.7V0a12.5,12.5,0,0,0-9.72,4.44L87.44,7.71l-.71.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M72.28,25.58l14.45-17h0a28.94,28.94,0,0,0-47.28,22.4H67.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M49.3,52.69h0l3.21-3.78h0l4.25-5H38.12A23.08,23.08,0,0,0,15.88,60.71,36.16,36.16,0,0,0,36.32,67l.86,0,7.21-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M35,44.1a23.07,23.07,0,0,1,3.13-.21H56.76l11-12.95H0A36.27,36.27,0,0,0,15.88,60.71,23.14,23.14,0,0,1,35,44.1Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4312a2be31e5cb90f30c25af6efbb0a1.svg";
export { ForwardRef as ReactComponent };